<template>
    <div>
      <AdSense />
      <AdSense />
      <section class="hero">
        <div class="hero-content">
          <img src="../assets/icon.jpg" alt="Gogo Icon" class="bot-icon" />
          <h1>Cosas que puedes hacer con GogoPoints</h1>
        </div>
      </section>

      <div class="page-container points-section">
        <h2>Gogo Points</h2>
        <p>Los Gogo Points son la moneda difundida por Gogo. Puedes ganar Gogo Points jugando a los juegos, participando en eventos y más.</p>
        <p>También puedes gastar tus Gogo Points en la tienda de Gogo.</p>
        <p>Para ver tu saldo de Gogo Points, simplemente escribe <code>!puntos</code> en tu servidor de confianza con Gogo.</p>
        <img src="../assets/gogoranger.jpg" alt="Gogo Ranger" class="feature-image" />
      </div>

      <div class="page-container hipica-section">
        <h2>Gogo Hípica</h2>
        <p>¿Te gustan los caballos? ¿Eres jugador de GTA V o Umamusume? Entonces Gogo Hípica es para ti.</p>
        <p>Gogo Hípica es un juego de carreras de caballos donde puedes apostar tus GogoPoints y ganar los de otros jugadores (siempre que tu caballo le sepa a correr).</p>
        <p>Para jugar, simplemente escribe <code>!carrera</code> en tu servidor de confianza con Gogo y sigue las instrucciones.</p>
        <p>También para ver todos los comandos puedes escribir <code>!hipica_help</code>.</p>
        <img src="../assets/yeguas.jpg" alt="Hipica" class="feature-image" />
      </div>
      
      <div class="page-container blackjack-section">
        <h2>Gogo Jack</h2>
        <p>¿Te gusta el Blackjack? ¿Te gusta Gogo? Entonces Gogo Jack es para ti.</p>
        <p>Gogo Jack es un juego de cartas donde puedes jugar al Blackjack contra Gogo y otros jugadores, apostando tus GogoPoints.</p>
        <p>Para jugar, simplemente escribe <code>!blackjack</code> en tu servidor de confianza con Gogo y sigue las instrucciones.</p>
        <img src="../assets/crupier.jpg" alt="Crupier" class="feature-image" />
      </div>
      
      <div class="page-container store-section">
        <h2>Gogo Store</h2>
        <p>¿Quieres comprar algo con tus GogoPoints? ¿Quieres ver qué cosas puedes comprar?</p>
        <p>Entonces Gogo Store es para ti.</p>
        <p>Gogo Store es una tienda donde puedes comprar cosas con tus GogoPoints, como terrenos, artículos coleccionables, etc.</p>
        <p>Para ver la tienda, simplemente escribe <code>!tienda</code> en tu servidor de confianza con Gogo.</p>
        <p>Para ver todos los comandos puedes escribir <code>!tienda_help</code>.</p>
        <img src="../assets/gogostore.jpg" alt="Gogo Store" class="feature-image" />
      </div>
    </div>
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
  </template>
  
  <script>
  import AdSense from './AdSense.vue';
  export default {
    name: "AppDeveloper",
    components: {
      AdSense
    }
  };
  </script>
  
<style scoped>
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 4rem 0;
  text-align: center;
}

.hero-content {
  margin: 0 auto;
  padding: 0 2rem;
}

.bot-icon {
  width: 200px;
  height: 200px;
  margin-bottom: 2rem;
}

h1 {
  color: white;
  font-size: 3rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

h2 {
  color: white;
  font-size: 2rem;
  margin-bottom: 1rem;
}

p {
  color: white;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.feature-image {
  width: 100%;
  border-radius: 8px;
  margin: 2rem auto;
  display: block;
  max-width: 800px;
}

.page-container {
  margin: 0 auto;
  padding: 2rem;
}

.blackjack-section {
  background-color: #3a4f7a;
}

.hipica-section {
  background-color: #2d5a27;
}

.store-section {
  background-color: #5a2d2d;
}

.points-section {
  background-color: #bba53d;
}

code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  font-family: 'Courier New', monospace;
  color: #000000;
  font-weight: bold;
}
</style>  